import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {StoreModule} from '@ngrx/store';
import {appReducer} from './core/store';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastModule} from 'primeng/toast';
import {ConfirmationService, MessageService} from 'primeng/api';
import {EffectsModule} from '@ngrx/effects';
import {AppEffects} from './core/store/app-effects';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {NotFoundComponent} from './not-found/not-found.component';
import {AppHttpInterceptor} from './core/app-http-interceptor';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {CalendarService} from "./core/services/calendar.service";
import {DialogService} from "primeng/dynamicdialog";
import {environment} from "../environments/environment";
import {PersistanceService} from "./core/services/persistance.service";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {providePrimeNG} from "primeng/config";
import {CustomPreset} from "./CustomThemePreset";

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    AppRoutingModule,
    StoreModule.forRoot({app: appReducer}),
    EffectsModule.forRoot([AppEffects]),
    BrowserAnimationsModule,
    AngularSvgIconModule.forRoot(),
    ToastModule,
    ConfirmDialogModule,
    ...environment.modules], providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: CustomPreset,
        options: {
          darkModeSelector: false,
        }
      }
    }),
    MessageService,
    PersistanceService,
    CalendarService,
    ConfirmationService,
    DialogService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
}
